<template>
  <form @submit.prevent="save">
    <vs-card
      class="flex flex-col justify-between p-5"
      fixedHeight
      style="min-height: 70vh"
    >
      <ResponseAlert ref="response" />
      <vs-row class="">
        <div class="w-full md:w-9/12 md:pr-3">
          <div class="w-full mb-5">
            <vs-input
              autocomplete="off"
              v-validate="'required'"
              label="Title"
              name="title"
              type="text"
              v-model="models.title"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('title')">{{
              errors.first("title")
            }}</span>
          </div>
          <div class="w-full mb-8">
            <label for="requirement">Requirement</label>
            <quill-editor
              v-validate="'required'"
              v-model="models.requirment"
              name="requirement"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('requirement')"
              >{{ errors.first("requirement") }}</span
            >
          </div>
          <div class="w-full mb-8">
            <label for="requirement">Community Guidelines</label>
            <quill-editor
              v-validate="'required'"
              v-model="models.guideline"
              name="community guideline"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('community guideline')"
              >{{ errors.first("community guideline") }}</span
            >
          </div>
          <div class="w-full mb-6">
            <label for="requirement">Social Media</label>
            <ul class="flex flex-col mt-3">
              <li
                v-for="(platform, platformIdx) in masters.platforms"
                :key="platformIdx"
                class="mr-4"
              >
                <label
                  :for="platform.name"
                  class="text-lg font-semibold flex items-center"
                >
                  <input
                    :id="platform.name"
                    type="checkbox"
                    name="platform"
                    v-model="vars.platformTypeId"
                    @change="platformChanges(platform)"
                    :value="platform.id"
                  />
                  <div class="ml-2">
                    <span>{{ platform.name }}</span>
                    <div
                      class="inline ml-1"
                      v-if="platform.icon"
                      v-html="platform.icon !== '<>' ? platform.icon : ''"
                    ></div>
                  </div>
                </label>

                <ul class="flex flex-col pl-6 my-2">
                  <li
                    class="campaign-subplatform-row"
                    v-for="(subPlatform, subIdx) in platform.subPlatform || []"
                    :key="
                      subPlatform ? subPlatform.id : `${platformIdx}-${subIdx}`
                    "
                  >
                    <label
                      :for="`${platform.name} - ${
                        subPlatform ? subPlatform.name : ''
                      }`"
                      class="text-base flex items-center"
                    >
                      <input
                        type="checkbox"
                        name="sub-platform"
                        v-model="vars.subPlatformTypeId"
                        @change="subPlatformChanges(platform)"
                        :id="`${platform.name} - ${
                          subPlatform ? subPlatform.name : subIdx
                        }`"
                        :value="subPlatform ? subPlatform.id : null"
                      />
                      <span class="ml-2 text-base">{{
                        subPlatform ? subPlatform.name : ""
                      }}</span>
                    </label>
                    <div
                      v-if="
                        subPlatform &&
                        vars.subPlatformTypeId &&
                        vars.subPlatformTypeId.includes(subPlatform.id)
                      "
                      class="campaign-link-inputs"
                    >
                      <label
                        class="campaign-link-field"
                        :for="`minimum-link-${subPlatform.id}`"
                      >
                        <span>Min</span>
                        <input
                          :id="`minimum-link-${subPlatform.id}`"
                          type="number"
                          min="1"
                          class="campaign-link-number"
                          :class="{
                            'border-danger': isSubPlatformLinkInvalid(subPlatform.id)
                          }"
                          v-model.number="
                            vars.subPlatformMinimumLinks[subPlatform.id]
                          "
                          @keydown="preventInvalidNumberInput"
                          @blur="normalizeSubPlatformInput(subPlatform.id, 'minimum')"
                        />
                      </label>
                      <label
                        class="campaign-link-field"
                        :for="`maximum-link-${subPlatform.id}`"
                      >
                        <span>Max</span>
                        <input
                          :id="`maximum-link-${subPlatform.id}`"
                          type="number"
                          min="1"
                          class="campaign-link-number"
                          :class="{
                            'border-danger': isSubPlatformLinkInvalid(subPlatform.id)
                          }"
                          v-model.number="
                            vars.subPlatformRequiredLinks[subPlatform.id]
                          "
                          @keydown="preventInvalidNumberInput"
                          @blur="normalizeSubPlatformInput(subPlatform.id, 'maximum')"
                        />
                      </label>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <!-- <input
              type="hidden"
              name="platform"
              :v-validate="models.approvmentType != 3 ? 'required' : ''"
              v-model="vars.platformTypeId"
            /> -->
            <span class="text-danger text-sm" v-show="errors.has('platform')"
              >Select min. 1 platform</span
            >
          </div>

          <div class="w-full mb-5">
            <label for="">Mention</label>
            <v-select
              :select-on-key-codes="[32, 13]"
              class="custom-vue-select"
              taggable
              multiple
              v-model="tags.mention"
              :closeOnSelect="false"
            />
            <!-- <small>* Press 'space'</small> -->
          </div>

          <div class="w-full mb-5">
            <label for="">Hashtag</label>
            <v-select
              :select-on-key-codes="[32, 13]"
              class="custom-vue-select"
              taggable
              multiple
              v-model="tags.hastag"
              :closeOnSelect="false"
            />
          </div>

          <div class="w-full mb-5">
            <vs-input
              autocomplete="off"
              v-validate="'required'"
              label="Link"
              name="link"
              type="url"
              v-model="models.link"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('link')">{{
              errors.first("link")
            }}</span>
          </div>

          <div class="w-full mb-5">
            <label>Sample Content</label>
            <vue-dropzone
              @vdropzone-success="successUpload"
              @vdropzone-removed-file="removeFile"
              duplicateCheck
              ref="myVueDropzone"
              id="dropzone"
              :options="dropzoneOptions"
            >
            </vue-dropzone>
          </div>
        </div>
        <div class="w-full md:w-3/12 mb-5 md:mb-0 pt-5">
          <div class="w-full mb-5">
            <img
              :src="getUrlOfFile(vars.thumbnail, true)"
              alt="image-profile"
              class="w-3/4 md:w-full block m-auto"
            />
            <vs-button
              color="primary"
              type="border"
              icon="upload_file"
              class="w-full mt-3"
              @click="$refs.file_upload.click()"
            >
              <span class="text-xs">Upload Thumbnail</span>
            </vs-button>
            <input
              ref="file_upload"
              type="file"
              accept="image/png, image/gif, image/jpeg, image/jpg"
              v-on:change="AddPhoto"
              hidden
            />
          </div>

          <h4>Campaign Setting</h4>
          <div class="w-full my-5">
            <label class="pl-2 text-sm" for="type">Campaign Category</label>
            <ul id="type" class="flex mt-3 justify-around">
              <li>
                <vs-radio v-model="models.type" vs-name="type" vs-value="1"
                  >Monthly</vs-radio
                >
              </li>
              <li>
                <vs-radio v-model="models.type" vs-name="type" vs-value="2"
                  >Special Campaign</vs-radio
                >
              </li>
            </ul>
            <span class="text-danger text-sm" v-show="errors.has('status')">{{
              errors.first("status")
            }}</span>
          </div>
          <div class="w-full my-5">
            <label class="pl-2 text-sm" for="status">Reward Type</label>
            <ul id="status" class="flex mt-3 justify-around">
              <li>
                <vs-radio
                  v-model="models.rewardType"
                  vs-name="status"
                  vs-value="1"
                  >Coin</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="models.rewardType"
                  vs-name="status"
                  vs-value="2"
                  >Loyalty</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="models.rewardType"
                  vs-name="status"
                  vs-value="3"
                  >Gift</vs-radio
                >
              </li>
            </ul>
            <span class="text-danger text-sm" v-show="errors.has('status')">{{
              errors.first("status")
            }}</span>
          </div>

          <div class="w-full mb-5" v-if="models.rewardType == 3">
            <label for="type">Select Product</label>
            <v-select
              class="w-full"
              name="productGift"
              :options="masters.products"
              label="name"
              :reduce="(product) => product.id"
              v-model="models.productGiftId"
            />
          </div>

          <div class="w-full mb-5" v-else>
            <vs-input
              autocomplete="off"
              v-validate="'required'"
              name="amount"
              @keypress="checkValidationNumber"
              @keydown="disableArrows"
              v-model="models.rewardAmount"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('amount')">{{
              errors.first("amount")
            }}</span>
          </div>

          <div class="w-full mb-5">
            <label for="type">Campaign Type</label>
            <v-select
              class="w-full"
              v-validate="'required'"
              name="campaign type"
              :options="masters.types"
              label="name"
              :reduce="(type) => type.id"
              v-model="models.campaignTypeId"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('campaign type')"
              >{{ errors.first("campaign type") }}</span
            >
          </div>

          <div class="w-full mb-5">
            <label for="type">Category</label>
            <v-select
              class="w-full"
              v-validate="'required'"
              name="category"
              :options="masters.categories"
              label="name"
              :reduce="(category) => category.id"
              v-model="models.categoryId"
            />
            <span class="text-danger text-sm" v-show="errors.has('category')">{{
              errors.first("category")
            }}</span>
          </div>

          <div class="w-full mb-8">
            <label for="type">Brand</label>
            <v-select
              class="w-full"
              v-validate="'required'"
              name="brand"
              :options="masters.brands"
              label="name"
              :reduce="(type) => type.id"
              v-model="models.brandId"
            />
            <span class="text-danger text-sm" v-show="errors.has('brand')">{{
              errors.first("brand")
            }}</span>
          </div>

          <div
            class="w-full mb-8 border border-solid border-grey p-3 rounded-lg relative"
          >
            <label
              class="absolute bg-white px-2"
              for=""
              style="top: -8px; left: 5px"
              >Campaign Registration</label
            >
            <div class="w-full mt-3 mb-5">
              <vs-input
                autocomplete="off"
                v-validate="'required'"
                label="Start Date"
                name="registration start date"
                type="datetime-local"
                v-model="models.campaignStartDate"
                :min="isCreateMode ? vars.start_regis : null"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('registration start date')"
                >{{ errors.first("registration start date") }}</span
              >
            </div>
            <div class="w-full mt-3 mb-5">
              <vs-input
                autocomplete="off"
                v-validate="'required'"
                label="End Date"
                name="registration end date"
                type="datetime-local"
                v-model="models.campaignEndDate"
                :min="vars.end_regis"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('registration end date')"
                >{{ errors.first("registration end date") }}</span
              >
            </div>
          </div>

          <div
            class="w-full mb-5 border border-solid border-grey p-3 rounded-lg relative"
          >
            <label
              class="absolute bg-white px-2"
              for=""
              style="top: -8px; left: 5px"
              >Campaign Duration</label
            >
            <div class="w-full mt-3 mb-5">
              <vs-input
                autocomplete="off"
                v-validate="'required'"
                label="Start Date"
                name="duration start date"
                type="datetime-local"
                v-model="models.durationStartDate"
                :min="vars.start_duration"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('duration start date')"
                >{{ errors.first("duration start date") }}</span
              >
            </div>
            <div class="w-full mt-3 mb-5">
              <vs-input
                autocomplete="off"
                v-validate="'required'"
                label="End Date"
                name="duration end date"
                type="datetime-local"
                v-model="models.durationEndDate"
                :min="models.durationStartDate"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('duration end date')"
                >{{ errors.first("duration end date") }}</span
              >
            </div>
          </div>

          <div
            class="w-full mb-5 border border-solid border-grey p-3 rounded-lg relative"
          >
            <label
              class="absolute bg-white px-2"
              for=""
              style="top: -8px; left: 5px"
              >Max Report Date</label
            >
            <div class="w-full mt-3 mb-5">
              <vs-input
                autocomplete="off"
                v-validate="'required'"
                label=""
                name="max submission date"
                type="datetime-local"
                v-model="models.maxSubmissionDate"
                :min="models.durationEndDate"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('max submission date')"
                >{{ errors.first("max submission date") }}</span
              >
            </div>
          </div>

          <div class="w-full my-5">
            <label class="pl-2 text-sm" for="status">Approvement</label>
            <ul id="status" class="mt-3">
              <li>
                <vs-radio
                  v-model="models.approvmentType"
                  vs-name="approvement"
                  vs-value="1"
                  class="mr-5"
                  >All With Approvement</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="models.approvmentType"
                  vs-name="approvement"
                  vs-value="2"
                  >All Without Approvement</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="models.approvmentType"
                  vs-name="approvement"
                  vs-value="3"
                  >Without Report</vs-radio
                >
              </li>
            </ul>
            <span
              class="text-danger text-sm"
              v-show="errors.has('approvement')"
              >{{ errors.first("approvement") }}</span
            >
          </div>

          <div class="w-full my-5">
            <vs-checkbox vs-name="highlight" v-model="models.isHighlight"
              >Highlight</vs-checkbox
            >
          </div>

          <div class="w-full mb-5">
            <label for="type">Target User</label>
            <v-select
              class="w-full"
              :options="masters.tiers"
              label="name"
              :reduce="(tier) => tier.id"
              v-model="models.tierId"
            />
          </div>

          <div class="w-full mb-5">
            <label for="type">Status</label>
            <v-select
              class="w-full"
              name="maritalStatus"
              multiple
              :options="masters.maritalStatus"
              label="name"
              :reduce="(maritalStatus) => maritalStatus.id"
              v-model="vars.maritalStatus"
            />
          </div>

          <div class="w-full mb-5">
            <vs-input
              label="Total Participant"
              @keypress="checkValidationNumber"
              v-model="models.participant"
              class="w-full"
            />
          </div>

          <div class="w-full mb-5">
            <label for="type">Send Product</label>
            <v-select
              class="w-full"
              name="product"
              multiple
              :options="masters.products"
              label="name"
              :reduce="(product) => product.id"
              v-model="vars.productId"
            />
          </div>
          <!-- per-subplatform inputs are shown inline next to each checkbox -->
          <div class="w-full mb-5">
            <label for="type">Channel Chat</label>
            <v-select
              class="w-full"
              name="channel"
              :options="masters.channels"
              label="subject"
              :reduce="(channel) => channel.id"
              v-model="models.channelId"
            />
            <span class="text-danger text-sm" v-show="errors.has('channel')">{{
              errors.first("channel")
            }}</span>
          </div>
        </div>
      </vs-row>

      <vs-row class="justify-start">
        <vs-button button="submit" color="success" type="filled" class="mr-3"
          >Publish</vs-button
        >
        <vs-button
          @click="save('draft')"
          color="primary"
          type="filled"
          class="mr-3"
          >Save as Draft</vs-button
        >
        <vs-button
          @click="$router.go(-1)"
          color="rgb(172,172,172)"
          type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-card>
  </form>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";
import api from "@/utils/api.js";
import {
  getUrlOfFile,
  uploadFile,
  checkValidationNumber,
} from "@/utils/helpers.js";

export default {
  name: "FormCampaign",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      checkValidationNumber,
      moment,
      getUrlOfFile,
      config: {
        uri: this.$route.meta.link,
      },
      models: {
        title: "",
        requirment: "",
        guideline: "",
        platformTypeId: [],
        subPlatformTypeId: [],
        mention: "",
        hastag: "",
        link: "",
        thumbnail: "",
        rewardType: "1",
        rewardAmount: "",
        campaignTypeId: "",
        type: 1,
        categoryId: "",
        brandId: "",
        campaignStartDate: "",
        campaignEndDate: "",
        durationStartDate: "",
        durationEndDate: "",
        maxSubmissionDate: "",
        approvmentType: "1",
        isHighlight: false,
        isDraft: false,
        tierId: "",
        productId: [],
        productGiftId: null,
        participant: "",
        sampleContent: [],
        // mapping of subPlatformId -> required links count
        subPlatformRequiredLinks: {},
        subPlatformMinimumLinks: {},
        channelId: null,
        maritalStatus: [],
      },
      masters: {
        types: [],
        categories: [],
        brands: [],
        tiers: [],
        products: [],
        channels: [],
        platforms: [],
        maritalStatus: [
          { id: 1, name: "Single" },
          { id: 2, name: "Menikah" },
          { id: 3, name: "Punya Anak" },
        ],
      },
      vars: {
        FormData: new FormData(),
        thumbnail: "",
        role_password: "required|min:8",
        platformTypeId: [],
        subPlatformTypeId: [],
        productId: [],
        sampleContent: [],
        // runtime map for required links per selected subplatform
        subPlatformRequiredLinks: {},
        subPlatformMinimumLinks: {},
        onLoadData: false,
        maritalStatus: [],

        // set min date campaign
        start_regis: moment().format("YYYY-MM-DDTHH:mm"),
        end_regis: moment().format("YYYY-MM-DDTHH:mm"),
        start_duration: moment().format("YYYY-MM-DDTHH:mm"),
        end_duration: moment().format("YYYY-MM-DDTHH:mm"),
      },
      tags: {
        mention: [],
        hastag: [],
      },
      dropzoneOptions: {
        url: "https://beau-api.demoapp.xyz/misc/upload",
        thumbnailWidth: 150,
        maxFilesize: 2,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        addRemoveLinks: true,
        dictDefaultMessage: "Upload Files Here",
      },
    };
  },
  created() {
    this.vars.onLoadData = true;
    Promise.all([this.getById(), this.getMasterOptions()]).then(() => {
      this.vars.onLoadData = false;
    });
  },
  methods: {
    disableArrows(event) {
      console.log(event.key);
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    },
    preventInvalidNumberInput(e) {
      // prevent typing 'e', '+', '-' and other non-numeric characters in number input
      if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
        e.preventDefault();
      }
    },
    parseLinkMap(value) {
      if (!value) return {};
      if (typeof value === "object" && !Array.isArray(value)) return value;
      try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
          ? parsed
          : {};
      } catch (e) {
        return {};
      }
    },
    setSubPlatformLinkDefaults(spId, minimumValue, maximumValue) {
      const max = parseInt(maximumValue, 10) || 1;
      const min = parseInt(minimumValue, 10) || max;
      this.$set(this.vars.subPlatformMinimumLinks, spId, Math.min(min, max));
      this.$set(this.vars.subPlatformRequiredLinks, spId, max);
    },
    notifyInvalidLink(text) {
      this.$vs.notify({
        title: "Invalid Link Total",
        text,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });
    },
    normalizeSubPlatformInput(spId, field) {
      let minimum = parseInt(this.vars.subPlatformMinimumLinks[spId], 10);
      let maximum = parseInt(this.vars.subPlatformRequiredLinks[spId], 10);

      if (Number.isNaN(minimum) || minimum < 1) minimum = 1;
      if (Number.isNaN(maximum) || maximum < 1) maximum = minimum;

      if (field === "minimum" && minimum > maximum) {
        maximum = minimum;
        this.notifyInvalidLink(
          `Maximum link campaign untuk ${this.findSubPlatformName(
            spId
          )} disesuaikan menjadi ${minimum}.`
        );
      }

      if (field === "maximum" && maximum < minimum) {
        maximum = minimum;
        this.notifyInvalidLink(
          `Jumlah link campaign untuk ${this.findSubPlatformName(
            spId
          )} minimal ${minimum}.`
        );
      }

      this.$set(this.vars.subPlatformMinimumLinks, spId, minimum);
      this.$set(this.vars.subPlatformRequiredLinks, spId, maximum);
    },
    isSubPlatformLinkInvalid(spId) {
      const minimum = Number(this.vars.subPlatformMinimumLinks[spId]);
      const maximum = Number(this.vars.subPlatformRequiredLinks[spId]);
      return (
        !Number.isInteger(minimum) ||
        !Number.isInteger(maximum) ||
        minimum < 1 ||
        maximum < 1 ||
        minimum > maximum
      );
    },
    getCampaignLinkRuleError() {
      const invalidSubPlatformId = this.vars.subPlatformTypeId.find((spId) =>
        this.isSubPlatformLinkInvalid(spId)
      );
      if (!invalidSubPlatformId) return null;

      return `Jumlah link campaign untuk ${this.findSubPlatformName(
        invalidSubPlatformId
      )} harus memiliki Min dan Max yang valid.`;
    },
    getById() {
      if (this.$route.params.id) {
        this.$axios
          .get(`${api.campaign}/${this.$route.params.id}`)
          .then((res) => {
            const { data } = res.data;
            this.models.title = data.title;
            this.models.type = data.type;
            this.models.requirment = data.requirment;
            this.models.guideline = data.guideline;
            // helper to parse array fields that may come as JSON strings
            const parseArrayField = (val) => {
              if (Array.isArray(val)) return val;
              if (typeof val === "string") {
                try {
                  const parsed = JSON.parse(val);
                  if (Array.isArray(parsed)) return parsed;
                } catch (e) {
                  // fallback: try comma-separated list between brackets or plain csv
                  const cleaned = val.replace(/[^0-9,]/g, "");
                  if (!cleaned) return [];
                  return cleaned
                    .split(",")
                    .map((s) => parseInt(s, 10))
                    .filter(Boolean);
                }
              }
              return [];
            };

            this.vars.platformTypeId = parseArrayField(data.platformTypeId);
            this.vars.subPlatformTypeId = parseArrayField(
              data.subPlatformTypeId
            );
            // init selected subplatform link rules from stored data if available
            try {
              const existingMaximum = this.parseLinkMap(
                data.subPlatformRequiredLinks
              );
              const existingMinimum = this.parseLinkMap(
                data.subPlatformMinimumLinks || data.sub_platform_minimum_links
              );
              this.vars.subPlatformMinimumLinks = {};
              this.vars.subPlatformRequiredLinks = {};
              this.vars.subPlatformTypeId.forEach((spId) => {
                this.setSubPlatformLinkDefaults(
                  spId,
                  existingMinimum[String(spId)] || existingMaximum[String(spId)],
                  existingMaximum[String(spId)]
                );
              });
            } catch (e) {
              this.vars.subPlatformMinimumLinks = {};
              this.vars.subPlatformRequiredLinks = {};
            }
            this.tags.mention = data.mention_serialize;
            this.tags.hastag = data.hastag_serialize;
            this.models.link = data.link;
            this.vars.thumbnail = data.thumbnail;
            this.models.rewardType = data.rewardType;
            this.models.rewardAmount = data.rewardAmount;
            this.models.campaignTypeId = data.campaignTypeId;
            this.models.categoryId = data.categoryId;
            this.models.brandId = data.brandId;
            this.models.campaignStartDate = moment(
              data.campaignStartDate
            ).format("YYYY-MM-DDTHH:mm");
            this.models.campaignEndDate = moment(data.campaignEndDate).format(
              "YYYY-MM-DDTHH:mm"
            );
            this.models.durationStartDate = moment(
              data.durationStartDate
            ).format("YYYY-MM-DDTHH:mm");
            this.models.durationEndDate = moment(data.durationEndDate).format(
              "YYYY-MM-DDTHH:mm"
            );
            this.models.maxSubmissionDate = moment(
              data.maxSubmissionDate
            ).format("YYYY-MM-DDTHH:mm");
            this.models.approvmentType = data.approvmentType;
            this.models.isHighlight = data.isHighlight;
            this.models.isDraft = data.isDraft;
            this.models.tierId = data.tierId;
            this.models.productGiftId = data.productGiftId;
            this.models.participant = data.participant;
            this.models.channelId = data.channelId;
            this.vars.productId = Array.isArray(data.products)
              ? data.products.map((product) => product.id)
              : parseArrayField(data.productId || data.products);

            if (
              Array.isArray(data.maritalStatus) &&
              data.maritalStatus.length > 0
            ) {
              this.vars.maritalStatus = data.maritalStatus.map((item) => item);
            } else {
              this.vars.maritalStatus = [];
            }

            this.models.maritalStatus = data.maritalStatus;

            data.sampleContent.forEach((url) => {
              const filename = url
                .substring(url.lastIndexOf("/") + 1)
                .split("?")[0];
              fetch(url)
                .then((res) => res.blob())
                .then((data) => {
                  const { size, type } = new File([data], filename);
                  let file = { size, name: filename, type };
                  this.$refs.myVueDropzone.manuallyAddFile(file, url);
                  this.vars.sampleContent.push({
                    name: file.name,
                    url,
                  });
                });
            });
          })
          .catch(() =>
            this.$router.push({
              name: "page404",
            })
          );
      }
    },
    getMasterOptions() {
      const getTypes = this.$axios.get(api.misc_campaignTypes);
      const getCategories = this.$axios.get(api.misc_categories);
      const getBrands = this.$axios.get(api.misc_brands);
      const getTiers = this.$axios.get(api.mics_tiers);
      const getProducts = this.$axios.get(api.misc_products);
      const getChannelsGroup = this.$axios.get(api.misc_channels_group);
      const getPlatforms = this.$axios.get(api.misc_campaign_platform);

      return Promise.all([
        getTypes,
        getCategories,
        getBrands,
        getTiers,
        getProducts,
        getChannelsGroup,
        getPlatforms,
      ]).then((res) => {
        this.masters.types = res[0].data.data;
        this.masters.categories = res[1].data.data;
        this.masters.brands = res[2].data.data;
        this.masters.tiers = res[3].data.data;
        this.masters.products = res[4].data.data;
        this.masters.channels = res[5].data.data.map((channel) => {
          channel.subject = channel.detail.subject;
          return channel;
        });
        this.masters.platforms = res[6].data.data.map((platform) => {
          return {
            ...platform,
            subPlatform: platform.subPlatform || [],
            icon:
              this.$store.state.socMedsIcons.find(
                (icon) => platform.name === icon.name
              ).icon || "<>",
            };
        });
      });
    },

    successUpload(file, response) {
      const url = response.data.file;
      this.vars.sampleContent.push({
        name: file.name,
        url,
      });
    },

    removeFile(file) {
      this.vars.sampleContent = this.vars.sampleContent.filter(
        (content) => content.name !== file.name
      );
    },

    AddPhoto(event) {
      let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
      if (event.target.files[0].size < fileSizeLimit) {
        this.vars.thumbnail = event.target.files[0];
      } else {
        this.$showToast("Failed", `Max file size is 2 MB`, "danger");
      }
    },

    save(isDraft) {
      const campaignLinkRuleError = this.getCampaignLinkRuleError();
      if (campaignLinkRuleError) {
        this.$refs.response.setResponseCustom(campaignLinkRuleError, "danger");
        window.scrollTo(0, 0);
        return;
      }

      this.vars.FormData = new FormData();
      const tags = ["mention", "hastag"];
      if (this.vars.platformTypeId) {
        this.models.platformTypeId = `[${this.vars.platformTypeId.join(",")}]`;
      }
      if (this.vars.subPlatformTypeId) {
        this.models.subPlatformTypeId = `[${this.vars.subPlatformTypeId.join(
          ","
        )}]`;
      }
      if (this.vars.productId) {
        this.models.productId = `[${this.vars.productId.join(",")}]`;
      }
      if (this.vars.maritalStatus) {
        this.models.maritalStatus = `[${this.vars.maritalStatus.join(",")}]`;
      }

      // ensure selected subplatform link maps only contain currently selected subplatforms
      Object.keys(this.vars.subPlatformRequiredLinks || {}).forEach((k) => {
        const keyNum = parseInt(k, 10);
        if (!this.vars.subPlatformTypeId.includes(keyNum)) {
          this.$delete(this.vars.subPlatformRequiredLinks, k);
          this.$delete(this.vars.subPlatformMinimumLinks, k);
        }
      });

      const sanitizedMaximum = {};
      const sanitizedMinimum = {};
      Object.keys(this.vars.subPlatformRequiredLinks || {}).forEach((k) => {
        const max = parseInt(this.vars.subPlatformRequiredLinks[k], 10) || 1;
        const min = parseInt(this.vars.subPlatformMinimumLinks[k], 10) || max;
        sanitizedMaximum[k] = max;
        sanitizedMinimum[k] = min;
      });
      this.models.subPlatformRequiredLinks = JSON.stringify(sanitizedMaximum);
      this.models.subPlatformMinimumLinks = JSON.stringify(sanitizedMinimum);

      if (this.models.rewardType === "3") {
        delete this.models.rewardAmount;
      }

      if (this.models.approvmentType != 3 && !this.vars.platformTypeId.length) {
        alert("Social Media is required");
        //this.$refs.response.setResponse("Social Media is required ", "danger");
      } else {
        this.models.sampleContent = `[${this.vars.sampleContent
          .map((c) => `"${c.url}"`)
          .join(",")}]`;
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            this.models.productGiftId = this.models.productGiftId || 0;
            this.models.isDraft = isDraft === "draft" ? true : false;
            this.models.thumbnail =
              typeof this.vars.thumbnail === "string"
                ? this.vars.thumbnail
                : await uploadFile(this.vars.thumbnail);
            tags.forEach((tag) => {
              if (this.tags[tag]) {
                this.models[tag] = this.tags[tag].map((tag) => tag).join(", ");
              }
            });

            this.models.campaignStartDate = moment(
              this.models.campaignStartDate
            ).format("YYYY-MM-DD HH:mm");
            this.models.campaignEndDate = moment(
              this.models.campaignEndDate
            ).format("YYYY-MM-DD HH:mm");
            this.models.durationEndDate = moment(
              this.models.durationEndDate
            ).format("YYYY-MM-DD HH:mm");
            this.models.durationStartDate = moment(
              this.models.durationStartDate
            ).format("YYYY-MM-DD HH:mm");
            this.models.maxSubmissionDate = moment(
              this.models.maxSubmissionDate
            ).format("YYYY-MM-DD HH:mm");

            for (const i in this.models) {
              this.vars.FormData.append(i, this.models[i]);
            }

            let request = "";
            let message = "create";

            if (!this.$route.params.id) {
              request = this.$axios.post(api.campaign, this.vars.FormData);
            } else {
              message = "update";
              request = this.$axios.put(
                `${api.campaign}/${this.$route.params.id}`,
                this.vars.FormData
              );
            }
            request
              .then(() => {
                this.$showToast("Success", `Success ${message} campaign`);
                this.$router.push({
                  name: this.config.uri,
                });
              })
              .catch((error) => {
                this.models.campaignStartDate = moment(
                  this.models.campaignStartDate
                ).format("YYYY-MM-DDTHH:mm");
                this.models.campaignEndDate = moment(
                  this.models.campaignEndDate
                ).format("YYYY-MM-DDTHH:mm");
                this.models.durationEndDate = moment(
                  this.models.durationEndDate
                ).format("YYYY-MM-DDTHH:mm");
                this.models.durationStartDate = moment(
                  this.models.durationStartDate
                ).format("YYYY-MM-DDTHH:mm");
                this.models.maxSubmissionDate = moment(
                  this.models.maxSubmissionDate
                ).format("YYYY-MM-DDTHH:mm");
                this.$refs.response.setResponse(error.response.data, "danger");
              });
          } else {
            window.scrollTo(0, 0);
          }
        });
      }
    },

    platformChanges(platform) {
      let platformSelected = this.vars.platformTypeId.find(
        (id) => id == platform.id
      );
      const subPlatformIds = (platform.subPlatform || []).map((sub) => sub.id);

      if (platformSelected) {
        this.vars.subPlatformTypeId = Array.from(
          new Set([...this.vars.subPlatformTypeId, ...subPlatformIds])
        );
        // add default link rules for newly included subplatforms
        subPlatformIds.forEach((spId) => {
          if (
            this.vars.subPlatformTypeId.includes(spId) &&
            !this.vars.subPlatformRequiredLinks[spId]
          ) {
            this.setSubPlatformLinkDefaults(spId, 1, 1);
          }
        });
      } else {
        this.vars.subPlatformTypeId = this.vars.subPlatformTypeId.filter(
          (el) => !subPlatformIds.includes(el)
        );
        // remove required-links entries for subplatforms that were removed
        subPlatformIds.forEach((spId) => {
          if (
            !this.vars.subPlatformTypeId.includes(spId) &&
            this.vars.subPlatformRequiredLinks[spId]
          ) {
            this.$delete(this.vars.subPlatformRequiredLinks, spId);
            this.$delete(this.vars.subPlatformMinimumLinks, spId);
          }
        });
      }
      // prune any entries not present in the current selection (handles individual unchecks)
      Object.keys(this.vars.subPlatformRequiredLinks || {}).forEach((k) => {
        const keyNum = parseInt(k, 10);
        if (!this.vars.subPlatformTypeId.includes(keyNum)) {
          this.$delete(this.vars.subPlatformRequiredLinks, k);
          this.$delete(this.vars.subPlatformMinimumLinks, k);
        }
      });
    },

    findSubPlatformName(id) {
      for (const p of this.masters.platforms) {
        if (!p.subPlatform) continue;
        const found = p.subPlatform.find((s) => s.id === id);
        if (found) return `${p.name} - ${found.name}`;
      }
      return id;
    },

    subPlatformChanges(platform) {
      const subPlatformIds = (platform.subPlatform || []).map((sub) => sub.id);
      const found = this.vars.subPlatformTypeId.some((sub) =>
        subPlatformIds.includes(sub)
      );
      if (found) {
        this.vars.platformTypeId = Array.from(
          new Set([...this.vars.platformTypeId, platform.id])
        );
        // ensure default link rule values exist for newly selected subplatforms
        subPlatformIds.forEach((spId) => {
          if (
            this.vars.subPlatformTypeId.includes(spId) &&
            !this.vars.subPlatformRequiredLinks[spId]
          ) {
            this.setSubPlatformLinkDefaults(spId, 1, 1);
          }
        });
      } else {
        this.vars.platformTypeId = this.vars.platformTypeId.filter(
          (platformId) => platformId !== platform.id
        );
        // remove entries for subplatforms that are unselected
        subPlatformIds.forEach((spId) => {
          if (
            !this.vars.subPlatformTypeId.includes(spId) &&
            this.vars.subPlatformRequiredLinks[spId]
          ) {
            this.$delete(this.vars.subPlatformRequiredLinks, spId);
            this.$delete(this.vars.subPlatformMinimumLinks, spId);
          }
        });
      }
      // prune any entries not present in the current selection (handles individual unchecks)
      Object.keys(this.vars.subPlatformRequiredLinks || {}).forEach((k) => {
        const keyNum = parseInt(k, 10);
        if (!this.vars.subPlatformTypeId.includes(keyNum)) {
          this.$delete(this.vars.subPlatformRequiredLinks, k);
          this.$delete(this.vars.subPlatformMinimumLinks, k);
        }
      });
    },
  },
  computed: {
     isCreateMode() {
      return !this.$route.params.id; // Jika tidak ada id, berarti mode create
    },
    startRegis() {
      return this.models.campaignStartDate;
    },
    startDuration() {
      return this.models.durationStartDate;
    },
    rewardType() {
      return this.models.rewardType;
    },
  },
  watch: {
    startRegis() {
      if (!this.vars.onLoadData) {
        this.vars.end_regis = moment(this.models.campaignStartDate).format(
          "YYYY-MM-DDTHH:mm"
        );
        this.vars.start_duration = moment(this.models.campaignStartDate).format(
          "YYYY-MM-DDTHH:mm"
        );
        this.vars.end_duration = moment(this.models.campaignStartDate).format(
          "YYYY-MM-DDTHH:mm"
        );
        if (
          moment(this.models.campaignStartDate).isAfter(
            this.models.campaignEndDate
          )
        ) {
          this.models.campaignEndDate = moment(
            this.models.campaignStartDate
          ).format("YYYY-MM-DDTHH:mm");
        }
        if (
          moment(this.models.campaignStartDate).isAfter(
            this.models.durationStartDate
          )
        ) {
          this.models.durationStartDate = moment(
            this.models.campaignStartDate
          ).format("YYYY-MM-DDTHH:mm");
        }
      }
    },
    startDuration() {
      if (!this.vars.onLoadData) {
        this.vars.end_duration = moment(this.models.durationStartDate).format(
          "YYYY-MM-DDTHH:mm"
        );
        if (
          moment(this.models.durationStartDate).isAfter(
            this.models.durationEndDate
          )
        ) {
          this.models.durationEndDate = moment(
            this.models.durationStartDate
          ).format("YYYY-MM-DDTHH:mm");
        }
      }
    },
  },
};
</script>

<style scoped>
.campaign-subplatform-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
}

.campaign-link-inputs {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(2, 72px);
  margin-left: 1.35rem;
  margin-top: 0.35rem;
}

.campaign-link-field {
  color: #626262;
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
  line-height: 1.2;
}

.campaign-link-number {
  border: 1px solid #d8d6de;
  border-radius: 4px;
  height: 30px;
  margin-top: 0.2rem;
  padding: 0 0.35rem;
  text-align: center;
  width: 72px;
}

@media (max-width: 360px) {
  .campaign-link-inputs {
    grid-template-columns: repeat(2, minmax(58px, 1fr));
    margin-left: 0;
  }

  .campaign-link-number {
    width: 100%;
  }
}
</style>
